import { Controller } from 'react-hook-form';
import { DateInput, Select, Table } from '@ui/src';
import { CreateFormTypes } from './types';
import {
  columns,
  columnsLabels,
} from '../../hoc/fintrac/variables/incoming-transactions';

import cn from './styles.module.css';

const CreateReportForm = ({
  control,
  errors,
  eftrTransactions,
  eftrTransactionsPagination,
  onRowSelect,
  transactionsTableVisible,
  transactionsIsLoading,
  transactionsIsFetching,
  filtersComponent,
  tableHandleSubmit,
  onClear,
  onTableSetPage,
  onSort,
  errorList,
  onTableFilter,
  sort,
  filters,
  selectedTransactionsIds,
}: CreateFormTypes) => (
  <div className={cn.eftrReportForm}>
    <div className={cn.formGroup}>
      <Controller
        control={control}
        defaultValue=""
        name="aggregationType"
        render={({ field: { value, name, onChange } }) => (
          <Select
            name={name}
            value={value}
            onChange={onChange}
            placeholder="Select type"
            title="Aggregation type"
            list={[
              {
                name: 'Sender',
                value: 'SENDER',
              },
              {
                name: 'Recipient',
                value: 'RECIPIENT',
              },
              {
                name: 'Single Transaction',
                value: 'SINGLE_TRANSACTION',
              },
            ]}
            error={errors?.aggregationType?.message}
            fullWidth
          />
        )}
      />
    </div>
    <div className={cn.formGroup}>
      <Controller
        control={control}
        defaultValue=""
        name="periodStart"
        render={({ field: { value, onChange } }) => (
          <DateInput
            title="Transfer Date"
            placeholder="Select date"
            value={value}
            onChange={(e) => {
              onChange(new Date(e).toISOString());
            }}
            error={errors?.periodStart?.message}
            className={errors?.periodStart?.message ? cn.dateInputError : ''}
            withoutCustomSelector
            fullWidth
          />
        )}
      />
    </div>
    {transactionsTableVisible && (
      <div className={cn.transactionTableWrapper}>
        <div className={cn.transcationTableTitle}>Incoming Transactions</div>

        <Table
          columns={columns}
          data={eftrTransactions || []}
          onSort={onSort}
          filters={{}}
          sort={sort}
          columnsLabels={columnsLabels}
          onFilterChange={(values) => {
            onTableFilter(values);
          }}
          filtersComponent={filtersComponent}
          error={errorList}
          handleSubmit={tableHandleSubmit}
          take="30"
          isLoading={transactionsIsLoading || transactionsIsFetching}
          setPage={({ id, take }) => {
            onTableSetPage({ id, take, filters });
          }}
          onRowsSelect={(ids) => onRowSelect(ids)}
          pagination={eftrTransactionsPagination}
          tableName="create-fintrac-report"
          onClearAutoComplete={onClear}
          selectedIds={selectedTransactionsIds}
          withScroll
          withVerticalScroll
          withToggleInput
          withSelectAllRowsOnExpand
        />
      </div>
    )}
  </div>
);

export default CreateReportForm;
